<template lang="pug">
div
  PageTitle

  v-card.mb-2
    v-form(v-if='preference')
      v-card-text
        v-subheader.pl-0(v-t='"appearance"')
        v-switch(color='primary' v-model='preference.isDarkTheme' hide-details)
          template(slot='label') {{ $t("applyDarkTheme") }}
        v-switch(color='primary' v-model='preference.isUsingNotoSans')
          div(slot='label')
            div {{ $t("useNotoSans") }}
            small {{ $t("uncheckForBetterPerformance") }}

        v-select.select(:items='formsRowsPerPageItems' item-value='value' item-text='text' v-model='preference.formsRowsPerPage' :label='$t("defaultLines")')

        template(v-if='preference.isDebugMode')
          v-subheader.pl-0(v-t='"debug"')
          v-switch(color='primary' v-model='preference.isDebugMode')
            div(slot='label')
              div(v-t='"debugMode"')
              small(v-t='"debugModeDescription"')

  DebugCodeBlock(:value='preference')
</template>

<script>
import preference from '@/assets/js/preference.js'
import PageTitle from '@/components/PageTitle.vue'

export default {
  name: 'Preference',
  metaInfo () {
    return {
      title: this.$t('偏好設定'),
    }
  },
  data () {
    this.formsRowsPerPageItems = [
      { value: 10, text: 10 },
      { value: 25, text: 25 },
      { value: 50, text: 50 },
      { value: -1, text: 'All' },
    ]
    return {
      preference: null,
    }
  },
  mounted () {
    this.preference = preference.get()
  },
  watch: {
    preference: {
      handler (_) {
        this.$store.commit('setPreference', _)
      },
      deep: true,
    },
  },
  components: {
    PageTitle,
  },
}
</script>

<style scoped lang="sass">
.select
  max-width: 15rem
</style>

<i18n src="@/lang/views/preference.json"></i18n>
